import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, TextField, Button, Stack, Select, MenuItem, Grid } from '@mui/material';
import axios from 'axios';

import { LoadingButton } from '@mui/lab';

export default function Main() {
  const [selectedEmail, setSelectedEmail] = useState('');
  const [selectedCopyTextTone, setSelectedCopyTextTone] = useState('');
  const [selectedTargetAudience, setSelectedTargetAudience] = useState('');
  const [productCollectionName, setProductCollectionName] = useState('');
  const [targetAudience, setTargetAudience] = useState('');
  const [productDescription, setProductDescription] = useState('');
  const [generatedContent, setGeneratedContent] = useState('');

  const [loading, setLoading] = useState(false);

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    if (name === 'email') {
      setSelectedEmail(value);
    } else if (name === 'copyTextTone') {
      setSelectedCopyTextTone(value);
    } else if (name === 'targetAudience') {
      setSelectedTargetAudience(value);
    }
  };

  const handleGenerateCopy = async () => {
    const prompt = `Email Type: ${selectedEmail}\nCopy Text Tone: ${selectedCopyTextTone}\nTarget Audience: ${selectedTargetAudience}\nProduct/Collection Name: ${productCollectionName}\nProduct/Service Description: ${productDescription}`;

    const data = {
      prompt: prompt,
      max_tokens: 200,
      model: 'text-davinci-002',
    };

    // Replace 'YOUR_OPENAI_API_KEY' with your actual OpenAI API key
    const headers = {
      Authorization: 'Bearer  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',
      'Content-Type': 'application/json',
    };

    try {
      setLoading(true); // Set loading to true to show the loading state
      const response = await axios.post('https://api.openai.com/v1/completions', data, { headers });
      const generatedText = response.data.choices[0].text;
      setGeneratedContent(generatedText);
      setLoading(false); // Set loading back to false on success
    } catch (error) {
      console.error('Error calling OpenAI API:', error);
      setGeneratedContent('Error generating content. Please try again later.');
      setLoading(false); // Set loading back to false on error
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" marginTop={4}>
      <Typography variant="h5" component="h2">
        Tell us more about your project
      </Typography>
      <Typography
        sx={{
          textAlign: { xs: 'center', sm: 'left' },
          marginTop: '20px',
        }}
      >
        Tell our AI more about your product/email, goal, and target audience language.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card style={{ marginTop: 20 }}>
            <CardContent>
              <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ display: 'flex' }}>
                <TextField
                  id="outlined-basic"
                  label="Your Landing Page or Website (example: aithrob.xyz.ai) "
                  variant="outlined"
                  sx={{ width: '100%' }}
                />
                <Button variant="contained" sx={{ width: '100%' }}>
                  Scan My Website
                </Button>
              </Stack>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                alignItems="center"
                justifyContent="center"
                marginTop={4}
              >
                <Select
                  name="email"
                  value={selectedEmail}
                  onChange={handleSelectChange}
                  variant="outlined"
                  sx={{ width: { xs: '100%', sm: '200px' } }}
                  displayEmpty // Show the first MenuItem as a placeholder
                >
                  <MenuItem value="" disabled>
                    Select Email Type
                  </MenuItem>
                  <MenuItem value="Wekesabuyahi@gmail.com">Wekesabuyahi@gmail.com</MenuItem>
                  <MenuItem value="jim@gmail.com">jim@gmail.com</MenuItem>
                  <MenuItem value="wanjigi@gmail.com">wanjigi@gmail.com</MenuItem>
                  {/* Add more menu items as needed */}
                </Select>

                <Select
                  name="copyTextTone"
                  value={selectedCopyTextTone}
                  onChange={handleSelectChange}
                  variant="outlined"
                  sx={{ width: { xs: '100%' } }}
                  displayEmpty // Show the first MenuItem as a placeholder
                >
                  <MenuItem value="" disabled>
                    Select Copy Text Tone
                  </MenuItem>
                  <MenuItem value="option1">Option 1</MenuItem>
                  <MenuItem value="option2">Option 2</MenuItem>
                  <MenuItem value="option3">Option 3</MenuItem>
                  {/* Add more menu items as needed */}
                </Select>

                <Select
                  name="targetAudience"
                  value={selectedTargetAudience}
                  onChange={handleSelectChange}
                  variant="outlined"
                  sx={{ width: { xs: '100%' } }}
                  displayEmpty // Show the first MenuItem as a placeholder
                >
                  <MenuItem value="" disabled>
                    Target Audience (i.e Returning Customers)
                  </MenuItem>
                  <MenuItem value="professional">Professional</MenuItem>
                  <MenuItem value="creative">Creative</MenuItem>
                  <MenuItem value="casual">Casual</MenuItem>
                  {/* Add more menu items as needed */}
                </Select>
              </Stack>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                alignItems="center"
                justifyContent="center"
                marginTop={4}
              >
                <TextField
                  id="outlined-basic"
                  name="productCollectionName"
                  label="Product/Collection Name (i.e aithrob.xyz.ai) "
                  variant="outlined"
                  sx={{ width: '100%' }}
                  onChange={(e) => setProductCollectionName(e.target.value)}
                />
                <TextField
                  id="outlined-basic"
                  name="targetAudience"
                  label="Target Audience (i.e Returning Customers) "
                  variant="outlined"
                  sx={{ width: '100%' }}
                  value={targetAudience} // Make sure to include the value prop to display the current state
                  onChange={(e) => setTargetAudience(e.target.value)}
                />
              </Stack>

              <TextField
                id="outlined-multiline-static"
                label={
                  'Product/Service description (i.e aithrob.xyz.ai is an artificial intelligence tool that creates and ' +
                  'designs emails such as flows & campaigns for brands. With aithrob.xyz.ai you can generate ' +
                  'email campaigns and flows within seconds.)'
                }
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                margin="normal"
                onChange={(e) => setProductDescription(e.target.value)}
              />
              <LoadingButton
                loading={loading}
                variant="contained"
                onClick={handleGenerateCopy}
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginTop: '20px',
                  textAlign: { xs: 'center', sm: 'left' },
                }}
              >
                Generate Copy
              </LoadingButton>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ marginTop: 2 }}>
            <CardContent>
              <Typography variant="h5" component="h2" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                Generated Content  
              </Typography>
              <pre
                style={{
                  whiteSpace: 'pre-wrap', // To wrap the text properly
                  textAlign: 'left', // Align the text to the left
                  marginTop: '10px', // Add some spacing above the pre element
                }}
              >
                {generatedContent}
              </pre>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}